import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils.js';

const alertVariants = cva(
  'relative w-full rounded-[var(--radius-container,var(--radius-lg))] border px-4 py-3 text-sm [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg+div]:translate-y-[-3px] [&:has(svg)]:pl-11',
  {
    variants: {
      variant: {
        default: 'border-[var(--color-border,var(--border))] bg-[var(--color-background-surface,white)] text-[var(--color-text-primary,var(--foreground))]',
        destructive: 'border-red-500/25 bg-red-500/10 text-red-900 dark:text-red-300',
        success: 'border-emerald-500/25 bg-emerald-500/10 text-emerald-900 dark:text-emerald-300',
        warning: 'border-amber-500/25 bg-amber-500/10 text-amber-900 dark:text-amber-300',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

const Alert = React.forwardRef(({ className, variant, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(alertVariants({ variant, className }))}
      role="alert"
      data-astryx-banner=""
      {...props}
    />
  );
});
Alert.displayName = 'Alert';

const AlertTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h5 ref={ref} className={cn('mb-1 font-semibold leading-none tracking-tight text-[var(--color-text-primary,var(--foreground))]', className)} {...props} />
));
AlertTitle.displayName = 'AlertTitle';

const AlertDescription = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('text-sm leading-relaxed text-[var(--color-text-secondary,var(--secondary))]', className)} {...props} />
));
AlertDescription.displayName = 'AlertDescription';

export { Alert, AlertTitle, AlertDescription, alertVariants };
